export default __webpack_public_path__ + "static/media/cdo_logo_uploader.3c15e608.png";